import React from 'react';

import { SearchResultsHeadless, SearchResultsList } from '@uncinc/react-searchkit';

import type {
  SearchAllContentArticleHit,
  SearchAllContentDefaultProfileHit,
  SearchAllContentHit,
  SearchAllContentProjectHit,
  SearchAllContentThemeHit,
  SearchAllContentVacancyHit,
} from '../../../SearchAllContent/types';

import SearchAllContentFacets from '../../../SearchAllContent/Facets';
import SearchAllContentPagination from '../../../SearchAllContent/Pagination';
import { sortByCustomOrder } from '../metaParagraphsHelpers';
import type { MetaSearchProps } from '..';

import ArticleHit from '../Results/ArticleHit';
import ProfileHit from '../Results/ProfileHit';
import ProjectHit from '../Results/ProjectHit';
import ThemeHit from '../Results/ThemeHit';
import VacancyHit from '../Results/VacancyHit';

const RenderItem = (hit: SearchAllContentHit) => {
  let type;

  if ('content_type' in hit) {
    const { content_type: contentType } = hit;
    [type] = contentType;
  } else if ('vid' in hit) {
    const { vid } = hit;
    [type] = vid;
  } else if ('profile_type' in hit) {
    const { profile_type: profileType } = hit;
    [type] = profileType;
  }

  switch (type) {
    case 'article': {
      return <ArticleHit hit={hit as SearchAllContentArticleHit} />;
    }
    case 'project': {
      return <ProjectHit hit={hit as SearchAllContentProjectHit} />;
    }
    case 'vacancy': {
      return <VacancyHit hit={hit as SearchAllContentVacancyHit} />;
    }
    case 'default_profile': {
      return <ProfileHit hit={hit as SearchAllContentDefaultProfileHit} />;
    }
    case 'themes': {
      return <ThemeHit hit={hit as SearchAllContentThemeHit} />;
    }
    default: {
      return <div />;
    }
  }
};

export type MetaSearchInnerProps = Pick<MetaSearchProps, 'sortingList' | 'withFacets' | 'withPagination'>;

const MetaSearchInner: React.FC<MetaSearchInnerProps> = (props) => {
  const {
    sortingList = undefined,
    withFacets = false,
    withPagination = false,
  } = props;

  return (
    <div className="MetaSearch">
      {withFacets && (
        <SearchAllContentFacets dialogEnabled={false} />
      )}

      <div className="MetaSearch__results">
        <SearchResultsHeadless>
          {(hits) => {
            const sortedItems = sortingList ? sortByCustomOrder(hits, sortingList) : hits;

            return (
              <SearchResultsList
                renderItem={RenderItem}
                hits={sortedItems}
              />
            );
          }}
        </SearchResultsHeadless>
      </div>

      {withPagination && (
        <SearchAllContentPagination />
      )}
    </div>
  );
};

export default MetaSearchInner;
